import React, { Component } from "react";
import { withRouter } from "react-router";
import { Card, Button, Form } from "antd";
import DateRangePicker from "../common/date-range-picker";
import MultiSelect from "../common/multi-select";
import { getDistinctValues } from "../../services/api-reexam";

const propsToStates = q => ({
  // convert url query to states
  applicationNumber: q.application_number,
  filingDate: q.filing_date,
  applicationStatus: q.application_status,
  statusDate: q.status_date,
  artUnit: q.art_unit,
  nationalClass: q.national_class,
  nationalSubclass: q.national_subclass,
  patentNumber: q.patent_number,
  examiner: q.examiner,
  lawFirm: q.law_firm,
  owner: q.owner,
  requester: q.requester,
  status: q.exparte_status
});

const stateKey2Field = {
  applicationNumber: "application_number",
  filingDate: "filing_date",
  applicationStatus: "application_status",
  statusDate: "application_status_date",
  artUnit: "examiner_art_unit",
  nationalClass: "national_class",
  nationalSubclass: "national_subclass",
  patentNumber: "patent_number",
  examiner: "examiner_name",
  lawFirm: "law_firm",
  owner: "owner",
  requester: "requester",
  status: "exparte_status"
};

class Toolbar extends Component {
  state = propsToStates(this.props.location.query);

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState(propsToStates(nextProps.location.query));
  }

  render() {
    return (
      <Card
        title={
          <span>
            {" Ex Parte"}
          </span>
        }
        extra={
          <Button size="small" onClick={this._onResetClick}>
            {"Reset"}
          </Button>
        }
      >
        <Form layout="vertical">
          {this.renderSelectFormItem("applicationNumber", "Application", "e.g. 90014558")}
          {this.renderSelectFormItem("patentNumber", "Patent", "e.g. 8676852")}
          {this.renderSelectFormItem("status", "Status", "e.g. Decision - Reexam Denied")}
          {this.renderDateFormItem("filingDate", "Filing Date")}
          {this.renderDateFormItem("statusDate", "Last Updated")}
          {this.renderSelectFormItem("artUnit", "Art Unit", "e.g. 3992")}
          {this.renderSelectFormItem("nationalClass", "Class", "e.g. 707")}
          {this.renderSelectFormItem("nationalSubclass", "Subclass", "e.g. 791000")}
          {this.renderSelectFormItem("examiner", "Examiner", "e.g. English, Peter C")}
          {this.renderSelectFormItem("lawFirm", "Law Firm", "e.g. Foley & Lardner LLP")}
          {this.renderSelectFormItem("owner", "Owner", "e.g. Sony Corporation")}
          {this.renderSelectFormItem("requester", "Requester", "e.g. Unified Patents LLC")}
        </Form>
      </Card>
    );
  }

  renderSelectFormItem = (key, label, placeholder, options, valueRenderer) => (
    <Form.Item label={label}>
      <MultiSelect
        value={this.state[key]}
        onChange={this._handleSelectChange(key)}
        options={options}
        optionApiCall={
          options
            ? undefined
            : val =>
              getDistinctValues(stateKey2Field[key], {
                [stateKey2Field[key]]: val || ""
              })
        }
        optionRender={valueRenderer}
        placeholder={placeholder}
      />
    </Form.Item>
  );

  renderDateFormItem = (key, label) => (
    <Form.Item label={label}>
      <DateRangePicker value={this.state[key]} onChange={this._handleSelectChange(key)} allowClear={true} />
    </Form.Item>
  );

  _handleSelectChange = stateKey => e =>
    this.setState(
      {
        [stateKey]: e
      },
      this._onSearchClick
    );

  _onSearchClick = () => {
    this.props.router.push({
      pathname: this.props.location.pathname,
      query: {
        application_number: this.state.applicationNumber,
        filing_date: this.state.filingDate,
        application_status: this.state.applicationStatus,
        status_date: this.state.statusDate,
        art_unit: this.state.artUnit,
        national_class: this.state.nationalClass,
        national_subclass: this.state.nationalSubclass,
        patent_number: this.state.patentNumber,
        examiner: this.state.examiner,
        law_firm: this.state.lawFirm,
        owner: this.state.owner,
        requester: this.state.requester,
        exparte_status: this.state.status
      }
    });
  };

  _onResetClick = () =>
    this.setState(
      {
        applicationNumber: undefined,
        filingDate: undefined,
        applicationStatus: undefined,
        statusDate: undefined,
        artUnit: undefined,
        nationalClass: undefined,
        nationalSubclass: undefined,
        patentNumber: undefined,
        examiner: undefined,
        lawFirm: undefined,
        owner: undefined,
        requester: undefined,
        status: undefined
      },
      () => {
        this.props.router.push({
          pathname: this.props.location.pathname,
          query: {
            sort: this.props.location.query.sort
          }
        });
      }
    );
}

export default withRouter(Toolbar);
